module.exports = {"id":"182862","name":"Maximiliano Pereira","rating":"78","photo":"./data/images/photos/0/182862.png","club":{"name":"FC Porto","logo":"./data/images/clubs/FCPorto.png"},"positions":["DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MaximilianoPereira0.json
// module id = 2953
// module chunks = 0